module.exports = __webpack_public_path__ + "static/media/portalBill.6ab83be0.svg";